import React, { Component, Fragment } from "react";
import DataGrid, {
  Column,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
} from "devextreme-react/data-grid";
import { getRequestParams, formatDate } from "../../helpers/globalfunctions.js";
import { axiosGet, axiosPost } from "../../apis/useAxios.js";
import { SelectBox } from "devextreme-react/select-box";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import RadioGroup from "devextreme-react/radio-group";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import moment from "moment";
import ReactDatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const rideType = [
  { id: 1, name: "Arrival" },
  { id: 2, name: "Departure" },
  { id: 3, name: "Both" },
];

const priorities = [
  { id: 1, text: "Individual" },
  { id: 2, text: "Broadcast" },
];

const notificationSourceLst = [
  { id: 1, text: "App" },
  { id: 2, text: "Email" },
];
const appTypeLst = [
  { id: 1, name: "IOS" },
  { id: 2, name: "Android" },
];
const DATE_RANGE_PRESETS = [
  { label: "Today", getRange: () => [moment(), moment()] },
  {
    label: "Yesterday",
    getRange: () => [moment().subtract(1, "day"), moment().subtract(1, "day")],
  },
  {
    label: "This Week",
    getRange: () => [moment().startOf("week"), moment().endOf("week")],
  },
  {
    label: "Last Week",
    getRange: () => [
      moment().subtract(1, "week").startOf("week"),
      moment().subtract(1, "week").endOf("week"),
    ],
  },
  {
    label: "This Month",
    getRange: () => [moment().startOf("month"), moment().endOf("month")],
  },
  {
    label: "Last Month",
    getRange: () => [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  },
];

let currentTime =
  sessionStorage.getItem("session_locationTime") === ""
    ? new Date()
    : new Date(sessionStorage.getItem("session_locationTime"));
export class NotificationComponent extends Component {
  static displayName = NotificationComponent.name;
  currentTime =
    sessionStorage.getItem("session_locationTime") === ""
      ? new Date()
      : new Date(sessionStorage.getItem("session_locationTime"));
  constructor(props) {
    super(props);
    this.state = {
      isSubmited: false,
      datasource: null,
      filterDropdownAirportDataSource: [],
      filterAirportCode: "",
      employeeDropdownDataSource: [],
      employeeId: 0,
      employeeNumber: "",
      dropdownRideType: [],
      rideTypeId: 0,
      notificationSource: notificationSourceLst[0],
      priority: priorities[0],
      notificationMessage: "",
      employeeNotifications: [],
      employeeSosNotifications: [],
      deviceNotifications: [],
      startDate: null,
      endDate: null,
      flightNo: "",
      appTypeId: 1,
      dropdownFcmMessageType: [],
      fcmMessageTypeId: 0,
      isShowPopup: false,
      errors: {
        appType: "",
        fcmMessageType: "",
        notificationMessage: "",
        employeeNumber: "",
      },
    };
    this.refDataGridEmployeeNotification = React.createRef();
    this.refDataGridDeviceNotification = React.createRef();
    this.refDataGridSos = React.createRef();
    this.refDateRangePicker = React.createRef();
  }

  applyDateRangePreset = (preset) => {
    try {
      const [start, end] = preset.getRange();
      this.setState({
        startDate: start.toDate(),
        endDate: end.toDate(),
      });
      if (this.refDateRangePicker.current) {
        this.refDateRangePicker.current.setOpen(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  isDateRangePresetActive = (preset) => {
    const [start, end] = preset.getRange();
    return (
      this.state.startDate &&
      this.state.endDate &&
      start.isSame(this.state.startDate, "day") &&
      end.isSame(this.state.endDate, "day")
    );
  };

  renderDateRangeCalendarContainer = ({ className, children }) => {
    return (
      <CalendarContainer className={className}>
        <div className="dc-daterange-shell">
          <div className="dc-daterange-presets">
            {DATE_RANGE_PRESETS.map((preset) => (
              <button
                key={preset.label}
                type="button"
                className={`dc-preset-btn${
                  this.isDateRangePresetActive(preset) ? " active" : ""
                }`}
                onClick={() => this.applyDateRangePreset(preset)}
              >
                {preset.label}
              </button>
            ))}
          </div>
          <div className="dc-daterange-months">{children}</div>
        </div>
      </CalendarContainer>
    );
  };

  async componentDidMount() {
    document.querySelector("#lblPageTitle").innerHTML =
      "Crew Activity Notification";
    this.callDashboardApi();
  }
  callDashboardApi = () => {
    try {
      setTimeout(async () => {
        await this.getDeviceNotifications();
      }, 0);
      setTimeout(async () => {
        await this.getEmployeeNotifications();
      }, 0);
      setTimeout(async () => {
        await this.getEmployeeSosNotifications();
      }, 0);
      setTimeout(async () => {
        await this.GetAirportDropdownList();
      }, 0);
      setTimeout(async () => {
        await this.getCrewMember();
      }, 0);
      setTimeout(async () => {
        await this.getRideTypeDropdownList();
      }, 0);
      setTimeout(async () => {
        await this.getFcmMessageTypeDropdown(this.state.appTypeId);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };
  getEmployeeNotifications = async () => {
    try {
      this.refDataGridEmployeeNotification.current.instance.beginCustomLoading();
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      const request = {
        AirlineCode: airlineCode,
        StartDate: this.state.startDate,
        EndDate: this.state.endDate ?? this.state.startDate,
      };

      const response = await axiosPost("Notification/Employee/", request);

      this.setState({
        employeeNotifications: response?.payload ?? [],
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getEmployeeNotifications function",
        err,
      );
    } finally {
      this.refDataGridEmployeeNotification.current.instance.endCustomLoading();
    }
  };
  getEmployeeSosNotifications = async () => {
    try {
      this.refDataGridSos.current.instance.beginCustomLoading();
      let airlineCode = sessionStorage.getItem("session_airlineCode");

      const request = {
        AirlineCode: airlineCode,
        StartDate: this.state.startDate,
        EndDate: this.state.endDate ?? this.state.startDate,
      };

      const response = await axiosPost(
        "Notification/SosNotification/",
        request,
      );

      this.setState({
        employeeSosNotifications: response?.payload ?? [],
      });
    } catch (err) {
      console.log(
        "Error in " +
          this.displayName +
          ".getEmployeeSosNotifications function",
        err,
      );
    } finally {
      this.refDataGridSos.current.instance.endCustomLoading();
    }
  };

  getDeviceNotifications = async () => {
    try {
      this.refDataGridDeviceNotification.current.instance.beginCustomLoading();

      let airlineCode = sessionStorage.getItem("session_airlineCode");

      const request = {
        AirlineCode: airlineCode,
        StartDate: this.state.startDate,
        EndDate: this.state.endDate ?? this.state.startDate,
      };

      const response = await axiosPost("Notification/Airline/", request);

      if (response?.isSuccess) {
        let data = response?.payload ?? [];

        let autoNotificationLst = data.map((el) => {
          el.receivedDate = this.convertUTCToLocal(el.receivedDate);
          return el;
        });

        this.setState({
          deviceNotifications: autoNotificationLst ?? [],
        });
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getDeviceNotifications function",
        err,
      );
    } finally {
      this.refDataGridDeviceNotification.current.instance.endCustomLoading();
    }
  };
  convertUTCToLocal = (utcDateTime) => {
    try {
      if (utcDateTime !== "") {
        if (!utcDateTime.toLowerCase().includes("utc")) {
          utcDateTime = `${utcDateTime} UTC`;
        }
        utcDateTime = new Date(utcDateTime).toLocaleString();
        utcDateTime = utcDateTime.replace(",", "");
      }
      return utcDateTime;
    } catch (ex) {
      console.log(ex);
      return "";
    }
  };
  GetAirportDropdownList = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");

      const response = await axiosGet(
        `Airport/get-airport-dropdown/${airlineCode}`,
      );

      this.setState((prev) => ({
        ...prev,
        filterDropdownAirportDataSource: response?.payload ?? [],
      }));
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".GetAirportDropdownList function",
        err,
      );
    }
  };

  getCrewMember = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");

      const response = await axiosPost("Crew/GetAllCrew", {
        AirlineCode: airlineCode,
        Status: "Active",
        AirportCode: this.state.filterAirportCode,
      });

      let airlineCrew = [
        ...new Set(
          response?.payload?.map((item) => {
            return {
              employeeNumber: item.employeeNumber,
              employeeName: `${item.employeeNumber} - ${item.firstName} ${item.lastName}`,
            };
          }),
        ),
      ];

      this.setState({
        employeeDropdownDataSource: airlineCrew,
        loadPanelVisible: false,
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getCrewMember function",
        err,
      );
    }
  };

  getRideTypeDropdownList = async () => {
    try {
      this.setState({ dropdownRideType: rideType });
    } catch (ex) {
      console.log(
        "Error in " + this.displayName + ".getStatusDropdownList function",
        ex,
      );
    }
  };
  handleInputChange = (event) => {
    event.preventDefault();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
    switch (name) {
      case "flightNo":
        setTimeout(() => {
          this.getCrewMember();
        }, 1000);
        break;
    }
    this.state.errors[name] = "";
  };

  handleCrewChange = async (e) => {
    if (e.selectedItem != null) {
      this.setState({
        employeeId: e.selectedItem.userId,
        employeeNumber: e.selectedItem.employeeNumber,
      });
    } else {
      this.setState({
        employeeId: 0,
        employeeNumber: "",
      });
    }
  };

  handleRideTypeChange = async (e) => {
    e.preventDefault();
    if (e.selectedItem != null) {
      this.setState({
        rideTypeId: e.selectedItem.Id,
      });
    } else {
      this.setState({
        rideTypeId: 0,
      });
    }
  };

  handleOnNotificationSourceChange = async (e) => {
    if (e.value !== null) {
      this.setState({ notificationSource: e.value });
    } else {
      this.setState({
        notificationSource: [],
      });
    }
  };

  handlePriorityChanged = async (e) => {
    let error = this.state.errors;
    error.employeeNumber = "";
    this.setState({ priority: e.value, employeeNumber: "", errors: error });
  };

  handleValidation = () => {
    let formIsValid = true;
    try {
      let error = this.state.errors;
      error.appType = "";
      error.fcmMessageType = "";
      error.notificationMessage = "";
      error.employeeNumber = "";
      if (Number(this.state.appTypeId) === 0) {
        formIsValid = false;
        error.appType = "Please select app type";
      }
      if (Number(this.state.fcmMessageTypeId) === 0) {
        formIsValid = false;
        error.fcmMessageType = "Please select topic";
      }
      if (
        this.state.notificationMessage.trim() === "" &&
        this.state.isShowPopup === true
      ) {
        formIsValid = false;
        error.notificationMessage = "Please enter notification message.";
      }
      if (this.state.priority.id === 1) {
        if (this.state.employeeNumber === "") {
          formIsValid = false;
          error.employeeNumber = "Please select employee.";
        }
      }
      this.setState({ errors: error });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleValidation function",
        err,
      );
      formIsValid = false;
    }
    return formIsValid;
  };

  handleNotificationSubmit = async (e) => {
    e.preventDefault();
    try {
      if (this.handleValidation()) {
        let airlineCode = sessionStorage.getItem("session_airlineCode");

        let request = {};
        request.AirlineCode = airlineCode;
        request.StartDate = this.state.startDate;
        request.EndDate = this.state.endDate ?? this.state.startDate;
        request.NotificationTypeId = Number(this.state.fcmMessageTypeId);
        request.NotificationText = this.state.notificationMessage;
        request.PriorityLevel = 1;
        request.AppTypeId = Number(this.state.appTypeId);
        request.EmployeeNumber = this.state.employeeNumber;
        request.AirportCode = this.state.filterAirportCode;
        request.FlightNumber = this.state.flightNo;
        request.NotificationSourceId = Number(
          this.state.notificationSource?.id ?? 1,
        );
        request.ShowPopup = this.state.isShowPopup;

        const response = await axiosPost(
          "Notification/InsertCrewNotification",
          request,
        );

        this.setState({ isSubmited: false });

        if (response?.isSuccess) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.message,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getEmployeeNotifications();
              this.getDeviceNotifications();
              this.handleClearNotification();
            }
          });
        } else {
          toast.error(response?.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
            style: { width: "310px" },
            hideProgressBar: false,
            newestOnTop: false,
            closeButton: false,
          });
        }
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".handleNotificationSubmit function",
        err,
      );
    }

    this.setState({ isSubmited: false });
  };

  handleClearNotification = async (e) => {
    this.setState({
      isSubmited: false,
      datasource: null,
      filterAirportCode: "",
      employeeId: 0,
      employeeNumber: "",
      rideTypeId: 0,
      notificationSource: notificationSourceLst[0],
      priority: priorities[0],
      notificationMessage: "",
      flightNo: "",
      appTypeId: 1,
      fcmMessageTypeId: 0,
      errors: {
        appType: "",
        fcmMessageType: "",
        notificationMessage: "",
        employeeNumber: "",
      },
    });
    setTimeout(() => {
      this.getCrewMember();
    }, 1000);
  };
  handleOnAppTypeChange = async (e) => {
    let appTypeId = e.selectedItem?.id ?? 1;
    let error = this.state.errors;
    error.appType = "";
    error.fcmMessageType = "";
    error.notificationMessage = "";
    this.setState({
      appTypeId: appTypeId,
      notificationMessage: "",
      errors: error,
    });
    await this.getFcmMessageTypeDropdown(appTypeId);
  };
  getFcmMessageTypeDropdown = async (appTypeId) => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");

      const response = await axiosGet(
        `Notification/fcm-messagetype-Dropdown/${airlineCode}/${appTypeId}`,
      );

      this.setState({
        dropdownFcmMessageType: response?.payload ?? [],
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getFcmMessageTypeDropdown function",
        err,
      );
    }
  };
  handleOnFcmMessageTypeChange = async (e) => {
    try {
      let error = this.state.errors;
      error.fcmMessageType = "";
      error.notificationMessage = "";
      let fcmMessageTypeId = e.selectedItem?.id ?? 0;
      let isShowPopup = e.selectedItem?.showPopup;
      let notificationMessage = "";
      if (fcmMessageTypeId !== 0) {
        notificationMessage =
          this.state.dropdownFcmMessageType?.filter(
            (f) => f.id === fcmMessageTypeId,
          )[0].notificationText ?? "";
      }
      this.setState({
        fcmMessageTypeId: fcmMessageTypeId,
        notificationMessage: notificationMessage,
        isShowPopup: isShowPopup,
        errors: error,
      });
    } catch (err) {
      console.log(
        "Error in " +
          this.displayName +
          ".handleOnFcmMessageTypeChange function",
        err,
      );
    }
  };
  render() {
    const renderDateTimeCell = (data) => {
      return formatDate(data.value, "hh:mm:ss a");
    };
    return (
      <Fragment>
        <style>{`
          /* ── Notification — theme matching sidebar #8E6448 ── */
          .ca-filter-card {
            background: #ffffff;
            border: none;
            border-radius: 10px;
            box-shadow: 0 2px 12px rgba(142,100,72,0.12);
            padding: 0 !important;
            overflow: hidden;
          }
          .dc-daterange-field {
            flex: 0 0 176px;
            min-width: 176px;
          }
          .dc-daterange-wrapper {
            display: block;
            width: 100%;
          }
          .dc-daterange-input {
            display: block;
            width: 100%;
            border: 1px solid #e3d5c6;
            border-radius: 6px;
            background: #fffdfb;
            padding: 5px 9px;
            min-height: 31px;
            font-size: 0.8rem;
            color: #333;
            box-sizing: border-box;
            outline: none;
            transition: border-color 0.15s ease;
          }
          .dc-daterange-input:hover {
            border-color: #d9c3aa;
          }
          .dc-daterange-input:focus {
            border-color: #f4691e;
            box-shadow: none;
          }
          .react-datepicker-popper {
            z-index: 1050;
          }
          .react-datepicker__day--in-range,
          .react-datepicker__day--in-selecting-range,
          .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
            background-color: #fdeee2;
            color: #6b4a2b;
          }
          .react-datepicker__day--keyboard-selected {
            background-color: #fdeee2;
            color: #6b4a2b;
          }
          .react-datepicker__day--range-start,
          .react-datepicker__day--range-end,
          .react-datepicker__day--selecting-range-start,
          .react-datepicker__day--selecting-range-end,
          .react-datepicker__day--selected {
            background-color: #f4691e;
            color: #ffffff;
          }
          .react-datepicker__header {
            background-color: #fdf7f2;
            border-bottom: 1px solid #e8d5c4;
          }
          .dc-daterange-shell {
            display: flex;
            align-items: stretch;
          }
          .dc-daterange-presets {
            display: flex;
            flex-direction: column;
            gap: 2px;
            padding: 8px 6px;
            background: #fdf7f2;
            border-right: 1px solid #e8d5c4;
            min-width: 112px;
          }
          .dc-preset-btn {
            border: none;
            background: transparent;
            text-align: left;
            padding: 6px 10px;
            font-size: 0.78rem;
            font-weight: 600;
            color: #6b4a2b;
            border-radius: 5px;
            cursor: pointer;
            white-space: nowrap;
            transition: background 0.15s ease, color 0.15s ease;
          }
          .dc-preset-btn:hover {
            background: #f5e7d8;
          }
          .dc-preset-btn.active {
            background: #f4691e;
            color: #ffffff;
          }
          .dc-daterange-months {
            position: relative;
          }
          /* Legacy range calendar styling */
          .leads-date-range-popover {
            position: absolute;
            top: 100%;
            right: 0;
            z-index: 9999;
            margin-top: 8px;
          }
          .rdrDateRangeWrapper {
            background: #ffffff !important;
            border-radius: 12px !important;
            box-shadow: 0 4px 24px rgba(142,100,72,0.15) !important;
            border: 1px solid #e8d5c4 !important;
            padding: 20px !important;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          }
          .rdrInputSeries {
            gap: 12px !important;
          }
          .rdrInputWrapper {
            background: #f8f3ed !important;
            border-radius: 8px !important;
            border: 1px solid #e0d0c4 !important;
            padding: 10px !important;
          }
          .rdrInputWrapper input {
            background: transparent !important;
            border: none !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #333333 !important;
          }
          .rdrInputWrapper input::placeholder {
            color: #999 !important;
          }
          .rdrMonth {
            width: 100% !important;
          }
          .rdrMonths {
            padding: 0 !important;
          }
          .rdrCaption {
            font-size: 15px !important;
            font-weight: 600 !important;
            color: #8E6448 !important;
            padding: 12px 0 !important;
          }
          .rdrMonthName {
            color: #8E6448 !important;
            font-weight: 600 !important;
          }
          .rdrWeekday {
            color: #8E6448 !important;
            font-weight: 600 !important;
            font-size: 12px !important;
            text-transform: uppercase !important;
            letter-spacing: 0.5px !important;
          }
          .rdrDay {
            font-size: 14px !important;
            color: #333333 !important;
          }
          .rdrDay:not(.rdrDayDisabled) {
            color: #333333 !important;
          }
          .rdrDayDisabled {
            background: #f5f5f5 !important;
            color: #ccc !important;
          }
          .rdrDayNumber {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-weight: 500 !important;
          }
          .rdrDayPassive {
            color: #ccc !important;
          }
          .rdrDayPassive .rdrDayNumber {
            color: #ccc !important;
          }
          .rdrDayHovered:not(.rdrDayDisabled) .rdrDayNumber {
            background: #f0e5da !important;
            color: #8E6448 !important;
            border-radius: 6px !important;
            font-weight: 600 !important;
          }
          .rdrDayInPreview {
            background: #fffaf5 !important;
          }
          .rdrDayStartPreview,
          .rdrDayEndPreview,
          .rdrDayInRange {
            background: #fff0e6 !important;
          }
          .rdrDayStartEdge,
          .rdrDayEndEdge,
          .rdrDayStart,
          .rdrDayEnd {
            background: #8E6448 !important;
            border-radius: 6px !important;
          }
          .rdrDayStart .rdrDayNumber,
          .rdrDayEnd .rdrDayNumber {
            color: #ffffff !important;
            font-weight: 600 !important;
          }
          .rdrDefinedRangesWrapper {
            border-right: 1px solid #e8d5c4 !important;
            padding-right: 16px !important;
            margin-right: 16px !important;
          }
          .rdrStaticRanges {
            gap: 6px !important;
          }
          .rdrStaticRange {
            background: #f8f3ed !important;
            border: 1px solid #e8d5c4 !important;
            border-radius: 6px !important;
            color: #333333 !important;
            font-size: 13px !important;
            font-weight: 500 !important;
            padding: 8px 12px !important;
            transition: all 0.2s ease !important;
          }
          .rdrStaticRange:hover {
            background: #f0e5da !important;
            border-color: #d4c5b9 !important;
            color: #8E6448 !important;
          }
          .rdrStaticRangeLabel {
            color: #333333 !important;
            font-size: 13px !important;
          }
          .rdrStaticRange.active {
            background: #8E6448 !important;
            border-color: #8E6448 !important;
            color: #ffffff !important;
          }
          .rdrStaticRange.active .rdrStaticRangeLabel {
            color: #ffffff !important;
            font-weight: 600 !important;
          }
          .rdrInputRanges {
            margin-bottom: 16px !important;
          }
          .rdrNextPrevButton {
            background: #f0e5da !important;
            border: 1px solid #e8d5c4 !important;
            border-radius: 6px !important;
            width: 32px !important;
            height: 32px !important;
            padding: 0 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            color: #8E6448 !important;
            font-weight: 600 !important;
          }
          .rdrNextPrevButton:hover {
            background: #8E6448 !important;
            color: #ffffff !important;
          }
          .rdrPpltRange {
            display: none !important;
          }
          .ca-filter-header {
            background: linear-gradient(135deg, #8E6448 0%, #b07d5c 100%);
            padding: 0.55rem 1.1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }
          .ca-filter-header span {
            color: #ffffff;
            font-size: 0.8rem;
            font-weight: 600;
            letter-spacing: 0.04em;
            text-transform: uppercase;
          }
          .ca-filter-header i {
            color: #FF6600;
            font-size: 0.85rem;
          }
          .ca-filter-body {
            padding: 0.75rem 1rem 0.5rem;
          }
          .ca-filter-body label {
            font-size: 0.73rem;
            font-weight: 600;
            color: #8E6448;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            margin-bottom: 0.25rem;
          }
          /* tabs */
          .ca-grid-wrap .nav-tabs .nav-link {
            color: #8E6448;
            font-weight: 600;
            font-size: 0.8rem;
          }
          .ca-grid-wrap .nav-tabs .nav-link.active {
            color: #8E6448;
            border-bottom: 2px solid #8E6448;
            background: transparent;
          }
          /* DataGrid header row */
          .ca-grid-wrap .dx-header-row td {
            background-color: #fff0e6 !important;
            color: #000000 !important;
            font-size: 0.76rem !important;
            font-weight: 600 !important;
            letter-spacing: 0.02em !important;
            border-color: rgba(255,255,255,0.15) !important;
          }
          .ca-grid-wrap .dx-datagrid-filter-row td {
            background-color: #f5ede4 !important;
          }
          .ca-grid-wrap .dx-datagrid {
            border-radius: 8px !important;
            overflow: hidden !important;
            box-shadow: 0 2px 10px rgba(142,100,72,0.1) !important;
          }
          .ca-grid-wrap .dx-toolbar {
            background: #fdf7f2 !important;
            border-bottom: 1px solid #e8d5c4 !important;
            padding: 0.35rem 0.6rem !important;
          }
        `}</style>
        <div className="filter-box mb-0">
          <div
            className="card ca-filter-card p-0 m-0"
            style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
          >
            <div className="ca-filter-body">
              {/* ── Row 1: Target ── */}
              <div className="row align-items-end mb-2">
                <div className="col-lg-2 col-md-2">
                  <div className="form-group mb-0">
                    <label>App Type</label>
                    <SelectBox
                      dataSource={appTypeLst}
                      placeholder="Select app type"
                      name="apptype"
                      defaultValue={1}
                      value={this.state.appTypeId || 1}
                      displayExpr="name"
                      valueExpr="id"
                      onSelectionChanged={this.handleOnAppTypeChange}
                      showClearButton={false}
                      searchEnabled={true}
                    />
                    {this.state.errors["appType"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["appType"]}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3">
                  <div className="form-group mb-0">
                    <label>Topic</label>
                    <SelectBox
                      dataSource={this.state.dropdownFcmMessageType}
                      placeholder="Select message type"
                      name="topic"
                      defaultValue={0}
                      value={this.state.fcmMessageTypeId}
                      displayExpr="topic"
                      valueExpr="id"
                      onSelectionChanged={this.handleOnFcmMessageTypeChange}
                      showClearButton={true}
                      searchEnabled={true}
                    />
                    {this.state.errors["fcmMessageType"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["fcmMessageType"]}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-2 col-md-2">
                  <div className="form-group mb-0">
                    <label>Airport</label>
                    <SelectBox
                      dataSource={this.state.filterDropdownAirportDataSource}
                      placeholder="Select Airport"
                      value={this.state.filterAirportCode}
                      displayExpr="airportName"
                      valueExpr="airportCode"
                      showClearButton={true}
                      searchEnabled={true}
                      onValueChanged={async (e) => {
                        try {
                          this.setState((prev) => ({
                            ...prev,
                            filterAirportCode: e.value ?? "",
                          }));
                        } catch (error) {}
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-2 col-md-2">
                  <div className="form-group mb-0">
                    <label>Flight No</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="flightNo"
                      placeholder="Enter Flight No"
                      maxLength="50"
                      value={this.state.flightNo}
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-3">
                  <div className="form-group mb-0">
                    <label>Notification Type</label>
                    <div style={{ paddingTop: "4px" }}>
                      <RadioGroup
                        items={notificationSourceLst}
                        value={this.state.notificationSource}
                        onValueChanged={this.handleOnNotificationSourceChange}
                        layout="horizontal"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* ── Divider ── */}
              <div
                style={{ borderTop: "1px solid #ede0d4", margin: "0.5rem 0" }}
              />

              {/* ── Row 2: Message & Send ── */}
              <div className="row align-items-end">
                <div className="col-lg-2 col-md-2">
                  <div className="form-group mb-0">
                    <label>Priority</label>
                    <div style={{ paddingTop: "4px" }}>
                      <RadioGroup
                        items={priorities}
                        value={this.state.priority}
                        layout="horizontal"
                        onValueChanged={this.handlePriorityChanged}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3">
                  <div className="form-group mb-0">
                    <label>Crew Member</label>
                    <SelectBox
                      dataSource={this.state.employeeDropdownDataSource}
                      placeholder="All Crew Members"
                      name="employeeNumber"
                      defaultValue={0}
                      value={this.state.employeeNumber}
                      displayExpr="employeeName"
                      valueExpr="employeeNumber"
                      onSelectionChanged={this.handleCrewChange}
                      showClearButton={true}
                      disabled={this.state.priority.id <= 1 ? false : true}
                      searchEnabled={true}
                    />
                    {this.state.errors["employeeNumber"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["employeeNumber"]}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-5 col-md-5">
                  <div className="form-group mb-0">
                    <label>Notification Message</label>
                    <textarea
                      id="notificationMessage"
                      className="form-control form-control-sm"
                      style={{ height: "34px", resize: "none" }}
                      maxLength="250"
                      placeholder="Type your message here..."
                      name="notificationMessage"
                      value={this.state.notificationMessage}
                      onChange={this.handleInputChange}
                    />
                    {this.state.errors["notificationMessage"].length > 0 && (
                      <span className="error invalid-feedback">
                        {this.state.errors["notificationMessage"]}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-2 col-md-2">
                  <div
                    className="form-group mb-0"
                    style={{ display: "flex", gap: "8px" }}
                  >
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm"
                      onClick={this.handleNotificationSubmit}
                    >
                      {this.state.isSubmited ? (
                        <span>
                          <i className="fas fa-spinner fa-spin" /> Sending
                        </span>
                      ) : (
                        <span>
                          <i className="fas fa-paper-plane" /> Send
                        </span>
                      )}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={this.handleClearNotification}
                    >
                      <i className="fas fa-eraser" /> Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card ca-grid-wrap mt-0"
          style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
        >
          <div className="card-body">
            <div
              className="d-flex justify-content-end mb-2"
              style={{ gap: "8px" }}
            >
              <div className="dc-daterange-field">
                <ReactDatePicker
                  ref={this.refDateRangePicker}
                  calendarContainer={this.renderDateRangeCalendarContainer}
                  selectsRange={true}
                  startDate={
                    this.state.startDate
                      ? moment(this.state.startDate).toDate()
                      : null
                  }
                  endDate={
                    this.state.endDate
                      ? moment(this.state.endDate).toDate()
                      : null
                  }
                  onChange={([start, end]) => {
                    this.setState({
                      startDate: start,
                      endDate: end,
                    });
                  }}
                  dateFormat="MM/dd/yyyy"
                  placeholderText="MM/dd/yyyy - MM/dd/yyyy"
                  onChangeRaw={(e) => e.preventDefault()}
                  className="dc-daterange-input"
                  wrapperClassName="dc-daterange-wrapper"
                  monthsShown={2}
                  showPopperArrow={false}
                  portalId="dc-daterange-portal"
                />
              </div>

              <button
                type="button"
                className="btn btn-sm"
                onClick={() => {
                  this.getEmployeeNotifications();
                  this.getDeviceNotifications();
                  this.getEmployeeSosNotifications();
                }}
                style={{
                  background: "#8E6448",
                  border: "1px solid #8E6448",
                  color: "#ffffff",
                  fontWeight: "600",
                  fontSize: "13px",
                  borderRadius: "6px",
                  padding: "6px 14px",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#6d5138";
                  e.target.style.borderColor = "#6d5138";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "#8E6448";
                  e.target.style.borderColor = "#8E6448";
                }}
              >
                <i className="fas fa-search"></i> Search
              </button>
            </div>

            <div>
              <ul
                className="nav nav-tabs mt-1 ml-2"
                id="custom-tabs-tab"
                role="tablist"
              >
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="custom-tabs-automated-tab"
                    data-toggle="pill"
                    href="#custom-tabs-automated"
                    role="tab"
                    aria-controls="custom-tabs-automated"
                    aria-selected="true"
                    value={0}
                  >
                    Automated
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="custom-tabs-manual-tab"
                    data-toggle="pill"
                    href="#custom-tabs-manual"
                    role="tab"
                    aria-controls="custom-tabs-manual"
                    aria-selected="false"
                    value={1}
                  >
                    Manual
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="custom-tabs-Sos-tab"
                    data-toggle="pill"
                    href="#custom-tabs-Sos"
                    role="tab"
                    aria-controls="custom-tabs-Sos"
                    aria-selected="false"
                    value={2}
                  >
                    SOS Notification
                  </a>
                </li>
              </ul>
            </div>
            <div
              className="tab-content tab-bordered"
              id="custom-tabs-tabContent"
            >
              <div
                className="tab-pane fade active show"
                id="custom-tabs-automated"
                role="tabpanel"
                aria-labelledby="custom-tabs-automated-tab"
              >
                <DataGrid
                  ref={this.refDataGridEmployeeNotification}
                  dataSource={this.state.employeeNotifications}
                  columnsAutoWidth={true}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  onCellPrepared={(e) => {
                    if (e.rowType === "header") {
                      e.cellElement.style.backgroundColor = "#fff0e6";
                      e.cellElement.style.color = "#000000";
                    }
                  }}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        onClick: async (e) => {
                          e.component.option("icon", "fas fa-spinner fa-spin");
                          await new Promise((resolve) =>
                            setTimeout(resolve, 1000),
                          ); // 0.5 sec
                          await this.getEmployeeNotifications();
                          e.component.option("icon", "refresh");
                        },
                      },
                    });
                  }}
                >
                  <Column
                    dataField="employeeNumber"
                    caption="Employee Number"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={140}
                    dataType="string"
                  />
                  <Column
                    dataField="firstName"
                    caption="First Name"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={150}
                  />
                  <Column
                    dataField="lastName"
                    caption="Last Name"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={150}
                  />
                  <Column
                    dataField="airlineCrewType"
                    caption="Crew Type"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={80}
                  />
                  <Column
                    dataField="airportCode"
                    caption="Airport Code"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={100}
                  />
                  <Column
                    dataField="pickupTime"
                    width={150}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    caption="Pickup Time"
                  />
                  <Column
                    dataField="flightTime"
                    width={150}
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    caption="Flight Time"
                  />
                  <Column
                    dataField="flightNumber"
                    caption="Flight Number"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={110}
                  />
                  <Column
                    dataField="title"
                    caption="Title"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={150}
                  />
                  <Column
                    dataField="notificationMessage"
                    caption="Notification"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={300}
                  />
                  <Column
                    dataField="processedTime"
                    caption="Processed Time"
                    allowSearch={true}
                    headerFilter={{ allowSearch: true }}
                    width={160}
                  />
                  <Column
                    dataField="entryTime"
                    caption="Created Date"
                    allowSearch={true}
                    format="dd/MM/yyyy"
                    headerFilter={{ allowSearch: true }}
                    width={160}
                  />
                  <SortByGroupSummaryInfo summaryItem="count" />
                  <GroupPanel visible={false} />
                  <HeaderFilter visible={true} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Grouping autoExpandAll={true} />
                  <Paging defaultPageSize={20} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true}
                    visible={true}
                  />
                  <Export
                    enabled={true}
                    allowExportSelectedData={false}
                    fileName="Employee Notifications"
                  />
                </DataGrid>
              </div>
              <div
                tabname={this.state.rowTabName}
                className="tab-pane fade"
                id="custom-tabs-manual"
                role="tabpanel"
                aria-labelledby="custom-tabs-manual-tab"
              >
                <DataGrid
                  ref={this.refDataGridDeviceNotification}
                  dataSource={this.state.deviceNotifications}
                  columnsAutoWidth={true}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        onClick: async (e) => {
                          e.component.option("icon", "fas fa-spinner fa-spin");
                          await new Promise((resolve) =>
                            setTimeout(resolve, 1000),
                          ); // 0.5 sec
                          await this.getDeviceNotifications();
                          e.component.option("icon", "refresh");
                        },
                      },
                    });
                  }}
                  onCellPrepared={(e) => {
                    if (e.rowType === "header") {
                      e.cellElement.style.backgroundColor = "#8E6448";
                      e.cellElement.style.color = "#ffffff";
                    }
                    if (
                      e.rowType === "data" &&
                      e.column.dataField === "statusName"
                    ) {
                      if (Number(e.data.statusId) > 0) {
                        e.cellElement.style.backgroundColor = "#ffcccb";
                        //e.cellElement.bgColor = "#FFFFE0";
                        //e.cellElement.style.color = "red";
                        if (Number(e.data.statusId) === 1) {
                          e.cellElement.style.backgroundColor = "#f5e611"; // open
                          e.cellElement.style.color = "#2e2d27";
                        }
                        if (Number(e.data.statusId) === 2) {
                          e.cellElement.style.backgroundColor = "#008000"; // success
                          e.cellElement.style.color = "#FFFFE0";
                        }
                        if (Number(e.data.statusId) === 3) {
                          e.cellElement.style.backgroundColor = "#999900"; // read
                          e.cellElement.style.color = "#FFFFE0";
                        }
                        if (Number(e.data.statusId) === 4) {
                          e.cellElement.style.backgroundColor = "#4a2d0d"; // expired
                          e.cellElement.style.color = "#FFFFE0";
                        }
                        if (Number(e.data.statusId) === 6) {
                          e.cellElement.style.backgroundColor = "#FF0000"; // failed
                          e.cellElement.style.color = "#FFFFE0";
                        }
                        if (Number(e.data.statusId) === 7) {
                          e.cellElement.style.backgroundColor = "#ad0303"; // invlid
                          e.cellElement.style.color = "#FFFFE0";
                        }
                      }
                    }
                  }}
                >
                  <Column
                    dataField="topic"
                    caption="Topic"
                    allowFiltering={false}
                    allowSearch={true}
                    width={150}
                  />
                  <Column
                    dataField="notificationText"
                    caption="Message"
                    allowFiltering={false}
                    allowSearch={true}
                    width={300}
                  />
                  <Column
                    dataField="appType"
                    caption="App Type"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="broadcastType"
                    caption="Broascast"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="priorityLevelText"
                    caption="Priority"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="notificationSource"
                    caption="Notification Type"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="statusName"
                    caption="Status"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="receivedDate"
                    caption="Send Date"
                    allowFiltering={false}
                    allowSearch={true}
                    width={300}
                    cellRender={renderDateTimeCell}
                  />
                  <Column
                    dataField="entryTime"
                    caption="Created Date"
                    allowSearch={true}
                    format="dd/MM/yyyy"
                    headerFilter={{ allowSearch: true }}
                    width={160}
                  />
                  <SortByGroupSummaryInfo summaryItem="count" />
                  <GroupPanel visible={false} />
                  <HeaderFilter visible={true} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Grouping autoExpandAll={true} />
                  <Paging defaultPageSize={20} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true}
                    visible={true}
                  />
                  <Export
                    enabled={true}
                    allowExportSelectedData={false}
                    fileName="Auto Notifications"
                  />
                </DataGrid>
              </div>
              <div
                className="tab-pane fade"
                id="custom-tabs-Sos"
                role="tabpanel"
                aria-labelledby="custom-tabs-Sos-tab"
              >
                <DataGrid
                  ref={this.refDataGridSos}
                  dataSource={this.state.employeeSosNotifications}
                  columnsAutoWidth={true}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  onCellPrepared={(e) => {
                    if (e.rowType === "header") {
                      e.cellElement.style.backgroundColor = "#8E6448";
                      e.cellElement.style.color = "#ffffff";
                    }
                  }}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        onClick: async (e) => {
                          e.component.option("icon", "fas fa-spinner fa-spin");
                          await new Promise((resolve) =>
                            setTimeout(resolve, 1000),
                          ); // 0.5 sec
                          await this.getEmployeeSosNotifications();
                          e.component.option("icon", "refresh");
                        },
                      },
                    });
                  }}
                >
                  <Column
                    dataField="employeeNumber"
                    caption="Employee Number"
                    allowFiltering={false}
                    allowSearch={true}
                    width={140}
                  />
                  <Column
                    dataField="firstName"
                    caption="First Name"
                    allowFiltering={false}
                    allowSearch={true}
                    width={150}
                  />
                  <Column
                    dataField="lastName"
                    caption="Last Name"
                    allowFiltering={false}
                    allowSearch={true}
                    width={150}
                  />
                  <Column
                    dataField="airlineCrewType"
                    caption="Crew Type"
                    allowFiltering={false}
                    allowSearch={true}
                    width={80}
                  />
                  <Column
                    dataField="airportCode"
                    caption="Airport Code"
                    allowFiltering={false}
                    allowSearch={true}
                    width={100}
                  />
                  <Column
                    dataField="pickupTime"
                    width={150}
                    allowFiltering={false}
                    allowSearch={true}
                    caption="Pickup Time"
                  />
                  <Column
                    dataField="flightTime"
                    caption="Flight Time"
                    allowFiltering={false}
                    allowSearch={true}
                    width={150}
                  />
                  <Column
                    dataField="flightNumber"
                    caption="Flight Number"
                    allowFiltering={false}
                    allowSearch={true}
                    width={110}
                  />
                  <Column
                    dataField="title"
                    caption="Title"
                    allowFiltering={false}
                    allowSearch={true}
                    width={80}
                  />
                  <Column
                    dataField="notificationMessage"
                    caption="Notification"
                    allowFiltering={false}
                    allowSearch={true}
                    width={700}
                  />
                  <Column
                    dataField="entryTime"
                    caption="Created Date"
                    allowSearch={true}
                    format="dd/MM/yyyy"
                    headerFilter={{ allowSearch: true }}
                    width={160}
                  />
                  <SortByGroupSummaryInfo summaryItem="count" />
                  <GroupPanel visible={false} />
                  <HeaderFilter visible={true} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Grouping autoExpandAll={true} />
                  <Paging defaultPageSize={20} />
                  <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                    showInfo={true}
                    visible={true}
                  />
                  <Export
                    enabled={true}
                    allowExportSelectedData={false}
                    fileName="Employee Notifications"
                  />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
